import StatusPage from '../shared/ui/feedback/StatusPage';

interface ConfigErrorProps {
  missing: readonly string[];
}

/**
 * Shown instead of the app when the build lacks required configuration.
 * StatusPage reads no configuration, so nothing here depends on what is
 * missing. The variable names stay: whoever deploys has to read them.
 */
export default function ConfigError({
  missing
}: ConfigErrorProps): JSX.Element {
  return (
    <main>
      <StatusPage icon="alert" title="Configuratiefout" alert>
        <p className="m-0">Deze build mist verplichte omgevingsvariabelen:</p>
        <ul className="m-0 mt-2 list-none p-0 font-mono">
          {missing.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </StatusPage>
    </main>
  );
}
